<template>
  <div class="from-dialog">
    <!-- 体验表单 -->
    <div class="form-box">
      <!-- 左侧 -->
      <div class="form-left">
        <div class="product-name">
          <span>轻骑兵</span>
          <span>低代码PaaS平台</span>
        </div>
        <div class="product-advantage">
          <span>扩展性强，支持二次开发</span>
          <span>可视化开发，原型即应用</span>
          <span>前后端分离，全量生成源代码</span>
        </div>
        <div class="tel">
          <img src="../../assets/img/formImg/tel.png">
          <span>400-600-7966</span>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="form-right">
        <img src="../../assets/img/formImg/close.png" class="close" @click="closeDialog">
        <iframe id="d6a9666c14e14c0a8acc035dfad371bb" width="100%" height="100%" frameborder="0" :src="iframeSrc" style="height: 100%" onload="this.style.height='100%'"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { sendCode, submitForm, queryCompanyName } from '../../api/form';

export default {
  name: 'HussarForm',
  props: {
    iframeSrc: {
      type: String,
      default: "https://app.swhudong.com/apply/d6a9666c14e14c0a8acc035dfad371bb"
    },
  },
  data() {
    return {
      formData: {
        companyname: '', // 企业名称
        username: '',
        phone: '',
        checkCode: '', // 验证码
        sourceway: '', // 访问途径
        registerProduct: '轻骑兵', // 注册信息的产品
        interestProduct: '轻骑兵', // 感兴趣产品
        concreteDemand: '轻骑兵低代码开发平台', // 具体需求
      },
      formRules: {
        companyname: [{ required: true, message: ' ', trigger: 'blur' },],
        username: [{ required: true, message: ' ', trigger: 'blur' },],
        phone: [{ required: true, message: ' ', trigger: 'blur' },],
        checkCode: [{ required: true, message: ' ', trigger: 'blur' },],
      },
      isSubmit: false,
      companies: [],
      isSend: false,
    };
  },
  methods: {
    checkLoading() {
      this.loading = false
    },
    // 查询单位名称
    async querySearch(queryString, cb) {
      const self = this;
      let resList = [];
      await queryCompanyName({word: queryString}).then((res) => {
        if ((res.status === '200' || res.status === 200)) {
          if(res.data.result !=null){
            resList = res.data.result.items || [];
            cb(resList);
          }
        } else {
          self.$message.error(res.data);
        }
      }).catch((error) => {
      });
      console.log(resList);
    },
    // 校验手机号
    checkPhone() {
      const self = this;
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(self.formData.phone)) {
        self.$message.error('请输入正确的联系方式!');
        return false;
      }
      return true;
    },
    // 发送验证码
    sendCode() {
      const self = this;
      self.isSend = true;
      if (!self.checkPhone()) {
        self.isSend = false;
        return;
      }
      sendCode(self.formData.phone).then((res) => {
        if ((res.status === '200' || res.status === 200) && res.data === '发送成功') {
          self.$message.success('验证码发送成功!');
        } else {
          self.$message.error(res.data);
        }
        self.isSend = false;
      }).catch((error) => {
        self.$message.error('验证码发送失败!');
        self.isSend = false;
      });
    },
    // 提交表单
    submit() {
      const self = this;
      let error = false;
      self.$refs.form.validate((valid) => {
        if (valid) {
          error = false;
        } else {
          error = true;
        }
      });
      if (error) {
        return;
      }
      const param = self.formData;
      submitForm(param).then((res) => {
        if ((res.status === '200' || res.status === 200) && res.data === '注册成功') {
          self.$message.success('提交成功!');
          self.isSubmit = true;
        } else {
          self.$message.error(res.data);
        }
      }).catch((error) => {
        self.$message.error('提交失败!');
      });
    },
    // 关闭弹窗
    closeDialog() {
      const self = this;
      self.$emit('closeForm');
    },
  },
  mounted() {},
}
</script>
<style scoped>
.from-dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.form-box {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  width: 790px;
  height: 590px;
  background: #FFF;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  z-index: 2000;
}
/* 左侧内容 */
.form-left {
  width: 320px;
  padding: 70px 0 0 56px;
  background: url('../../assets/img/formImg/left-back.png');
  background-size: 100%;
}
.product-name {
  margin-bottom: 35px;
  font-size: 28px;
  font-weight: bold;
  color: #FFF;
  line-height: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
}
.product-name span,
.product-advantage span {
  display: block;
}
.product-advantage {
  margin-bottom: 24px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFF;
  line-height: 36px;
}
.tel {
  display: flex;
  align-items: center;
}
.tel span {
  margin-left: 8px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #AEE8FA;
}

/* 右侧表单 */
.form-right {
  position: relative;
  width: 470px;
}
.form-con-box {
  padding: 57px 70px 0;
}
.form-right img.close {
  position: absolute;
  top: 18px;
  right: 21px;
  cursor: pointer;
}
.form-con-box .form-title {
  margin-bottom: 24px;
  font-size: 24px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #018DFF;
  line-height: 33px;
  text-align: center;
}
.form-con >>> .el-form-item {
  position: relative;
  margin-bottom: 0;
}
.form-con >>> .el-form-item .el-form-item__label {
  padding: 0;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #60646B;
  line-height: 22px;
}
.star {
  color: #FF5804;
}
.form-con >>> .el-form-item .el-input__inner {
  width: 100%;
  height: 46px;
  margin-bottom: 12px;
  padding-left: 10px;
  border: 1px solid #D3D6DB;
  border-radius: 4px;
  line-height: 46px;
}
.form-con >>> .el-form-item.is-error .el-input__inner {border: 1px solid #F56C6C;}
.form-con >>> .el-form-item .el-form-item__content > div {
  width: 100%;
}
.form-con span.code {
  position: absolute;
  top: 13px;
  right: 12px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #186CF5;
  line-height: 20px;
  cursor: pointer;
}
.form-con-box .form-btn {
  width: 100%;
  height: 46px;
  margin-top: 20px;
  background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
  border: none;
  color: #FFF;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
}
.form-con-box .form-btn:hover {
  background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
}
.form-con >>>  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {display: none;}

/* 提交成功 */
.submit-success {
  padding-top: 162px;
  text-align: center;
}
.submit-success img {
  margin-bottom: 30px;
}
.submit-success .success-title {
  margin-bottom: 7px;
  font-size: 24px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #202124;
  line-height: 33px;
}
.submit-success .success-tip {
  margin-bottom: 80px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #202124;
  line-height: 22px;
}
.submit-success .success-btn {
  width: 110px;
  height: 46px;
  background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);
  border: none;
  border-radius: 4px;
  color: #FFF;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
}
.submit-success .success-btn:hover {
  background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);
}
.isDisabled {
  pointer-events: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/include/HussarForm.vue